/* We Velvet landing sections (sections/wv-lp-*.liquid): reveal on scroll and the FAQ accordion (one question open
   at a time). Every section loads this file; it runs once. In the theme editor everything stays visible. */
(() => {
  if (window.wvLpReady) return;
  window.wvLpReady = true;
  const editor = window.Shopify && Shopify.designMode;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = () => {
    if (editor || reduce || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    }), { threshold: 0.1 });
    document.querySelectorAll('.wv-lp-fade:not(.is-in)').forEach((el) => io.observe(el));
    document.documentElement.classList.add('wv-lp-js');
  };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.wv-lp-acc > button');
    if (!btn) return;
    const item = btn.parentElement;
    const open = item.classList.contains('is-open');
    item.parentElement.querySelectorAll('.wv-lp-acc.is-open').forEach((a) => {
      a.classList.remove('is-open');
      a.firstElementChild.setAttribute('aria-expanded', 'false');
      a.firstElementChild.lastElementChild.textContent = '+';
    });
    if (!open) {
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      btn.lastElementChild.textContent = '−';
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();
})();
